/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    TextField,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import ModalEncabezado from 'Infotrack@Transversales/componentes/ModalEncabezado/ModalEncabezado';
import React from 'react';
import { IFormularioUnidadesVistaProps } from '../interfaces';
import { estadoActivo } from 'Infotrack@Transversales/constantes/ConstantesEstados';

const FormularioUnidadesVista: React.FunctionComponent<IFormularioUnidadesVistaProps> = ({
    accionCrearEditar,
    alCambiarValor,
    alCambiarValorAutoComplete,
    cerrarFormulario,
    estadoFormulario,
    unidades,
    tipoFormulario,
    tiposUnidades,
}) => (
    <Dialog open={estadoFormulario}>
        <ModalEncabezado
            cerrar={cerrarFormulario}
            titulo={
                <Texto
                    align="center"
                    color="inherit"
                    id={
                        tipoFormulario === TipoFormulario.Creacion
                            ? 'unidades.agregarUnidades'
                            : tipoFormulario === TipoFormulario.Edicion
                                ? 'unidades.modificarUnidades'
                                : 'unidades.VerUnidad'
                    }
                />
            }
        />
        <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Autocomplete
                        getOptionLabel={({ DescripcionTipoUnidad }) => DescripcionTipoUnidad}
                        onChange={(_: any, tipoUnidad: any) => alCambiarValorAutoComplete(tipoUnidad)}
                        options={tiposUnidades.filter((x) => x.Estado === true || x.Estado === estadoActivo)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                fullWidth
                                label={<Texto id="unidades.tipoUnidadId" display="inline" />}
                                helperText={tipoFormulario === TipoFormulario.Edicion && unidades.TipoUnidad == null ? (
                                    <Texto id="unidades.TipoUnidadInactivo" />) : ('')
                                }
                                error={tipoFormulario === TipoFormulario.Edicion && !tiposUnidades.find(
                                    (x) => unidades.TipoUnidad && x.TipoUnidadId === unidades.TipoUnidad!.TipoUnidadId) ? true : false
                                }
                            />
                        )}
                        noOptionsText={<Texto id="label.sinRegistros" />}
                        value={unidades.TipoUnidad}
                        id={`CampoTipoUnidad-${unidades.TipoUnidad}`}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="unidades.descripcionUnidad" display="inline" />}
                        inputProps={{ readOnly: tipoFormulario === TipoFormulario.Visualizacion }}
                        name="DescripcionUnidad"
                        onChange={alCambiarValor}
                        required
                        value={unidades.DescripcionUnidad}
                        id={`CampoDescripcionUnidad-${unidades.DescripcionUnidad}`}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="unidades.abreviatura" display="inline" />}
                        inputProps={{ readOnly: tipoFormulario === TipoFormulario.Visualizacion }}
                        name="Abreviatura"
                        onChange={alCambiarValor}
                        required
                        value={unidades.Abreviatura}
                        id={`CampoAbreviatura-${unidades.Abreviatura}`}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={Number(unidades.Estado) === 1 ? true : false}
                                onChange={alCambiarValor}
                            />
                        }
                        label={<Texto id="perfil.estado" display="inline" />}
                        disabled={tipoFormulario === TipoFormulario.Visualizacion ? true : false}
                        id={`Estado`}
                        name="Estado"
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            {tipoFormulario !== TipoFormulario.Visualizacion ? (
                <div>
                    <Grid container justifyContent="flex-end" spacing={2}>
                        <Grid item>
                            <Button onClick={cerrarFormulario} color="secondary" variant="contained" id="boton-cancelarUnidad">
                                <Texto id="boton.cancelar" />
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button onClick={accionCrearEditar} color="primary" variant="contained" id="boton-editarUnidad">
                                <Texto id="boton.guardar" />
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            ) : (
                <Button onClick={cerrarFormulario} color="secondary" variant="contained" id="boton-cerrar">
                    <Texto id="boton.cerrar" />
                </Button>
            )}
        </DialogActions>
    </Dialog>
);

export default FormularioUnidadesVista;
